import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { showSquadModal } from '../../actions/squad';

import './SquadCard.css';


export const SquadCardType = {
  Primary: 'SquadCardType.Primary',
  Secondary: 'SquadCardType.Secondary',
  Tertiary: 'SquadCardType.Tertiary',
  Plain: 'SquadCardType.Plain',
};

class SquadCard extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.keys(SquadCardType).map(k => SquadCardType[k])).isRequired,
    squad: PropTypes.shape({
      name: PropTypes.string.isRequired,
      img: PropTypes.string,
      shortDesc: PropTypes.string,
    }).isRequired,

    // Redux Dispatch.
    showSquadModal: PropTypes.func.isRequired,
  };

  onClick = (e) => {
    e.preventDefault();
    this.props.showSquadModal(this.props.squad);
  }

  renderPrimary = () => {
    const { squad: { name, img, shortDesc } } = this.props;

    return (
      <button className="squad-card primary button" onClick={this.onClick} >
        <div className="row vertical-align hidden-xs hidden-sm">
          <div className="col-md-4">
            <div className="image">
              <img className="img-circle img-responsive full-width" src={img} alt="" />
            </div>
          </div>
          <div className="col-md-8">
            <p className="name">{name}</p>
            <p className="desc">{shortDesc}</p>
          </div>
        </div>
        <div className="row visible-xs visible-sm">
          <div className="col-xs-offset-3 col-xs-6">
            <div className="image">
              <img className="img-circle img-responsive full-width" src={img} alt="" />
            </div>
          </div>
          <div className="col-xs-12">
            <p className="name">{name}</p>
            <p className="desc">{shortDesc}</p>
          </div>
        </div>
      </button>
    );
  };

  renderSecondary = () => {
    const { squad: { name, img, shortDesc } } = this.props;

    return (
      <button className="squad-card secondary button" onClick={this.onClick} >
        <div className="row vertical-align">
          <div className="col-xs-3">
            <div className="image">
              <img className="img-circle img-responsive full-width" src={img} alt="" />
            </div>
          </div>
          <div className="col-xs-9">
            <p className="desc">
              <span className="name">{name}.</span>&nbsp;
              <span>{shortDesc}</span>
            </p>
          </div>
        </div>
      </button>
    );
  };

  renderTertiary = () => this.renderSecondary();

  renderPlain = () => {
    const { squad: { name } } = this.props;

    return (
      <div className="squad-card plain">
        <p className="name">{name}</p>
      </div>
    );
  };

  render() {
    const { type } = this.props;
    const renderer = this[`render${type.split('.')[1]}`];
    return renderer();
  }
}

export const mapDispatchToProps = {
  showSquadModal,
};

export default connect(null, mapDispatchToProps)(SquadCard);



// WEBPACK FOOTER //
// ./src/components/SquadPage/SquadCard.js